import { computed } from 'vue'
import { WORK_ORDERS_OVERVIEW_TRANSLATION_NAMESPACE as NS } from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/config/constants'

/**
 * The "Podaci o izvršenju" fields of a work order: how far it got, read off the
 * coverage snapshot the driver's app reports against. Read-only, like the rest of the
 * screen - the order's progress is reported to the backend, never typed in here.
 *
 * One field per row, so the block reads as the single column the design shows beside
 * the map.
 */
export function useWorkOrderExecutionFields (options) {
  const { translate } = options || {}

  const readOnlyField = (key, label) => ({
    key,
    label,
    editable: false,
    creatable: false,
    visible: true
  })

  // Two groups, in this order: what was driven, then when. A dispatcher opens this tab to
  // read how far the order got, and reaches for the times only once something in the
  // figures needs explaining.
  const fields = computed(() => ([
    readOnlyField('status', translate(`${NS}.status`)),
    readOnlyField('coverage_percent', translate(`${NS}.cleaned`)),
    readOnlyField('kilometres_travelled', translate(`${NS}.kilometres_travelled`)),
    readOnlyField('visited_points', translate(`${NS}.visited_points`)),
    readOnlyField('streets_summary', translate(`${NS}.streets_summary`)),
    readOnlyField('irregularity_count', translate(`${NS}.irregularities`)),
    readOnlyField('planned_from', translate(`${NS}.planned_start`)),
    readOnlyField('planned_to', translate(`${NS}.planned_end`)),
    readOnlyField('taken_at', translate(`${NS}.taken_at`)),
    readOnlyField('completed_at', translate(`${NS}.finished_at`)),
    readOnlyField('elapsed', translate(`${NS}.elapsed`)),
    readOnlyField('work_time', translate(`${NS}.work_time`))
  ]))

  return {
    fields
  }
}
